<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list ">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/club/about">About Us</a></li>
                            <li><a routerLink="/club/premier-outdoor-venue" class="active">Uptonsteel County Ground</a></li>
                            <!-- <li><a routerLink="/recruitment">Recruitment</a></li> -->
                            <li><a routerLink="/contact" > Contact Us</a></li>                                                          
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="club-hero-section cf">
            <div class="tab-section">
                <div class="container">
                    <ul>
                        <li class="courses-name active " id="premier-outdoor"><a routerLink="/club/premier-outdoor-venue">Premier Outdoor Venue </a></li>
                        <li class="courses-name  " id="directions"><a routerLink="/club/directions">Directions</a></li>
                        <li class="courses-name " id="ground-regulations"><a routerLink="/club/ground-regulations">Ground Regulations</a></li>
                        <li class="courses-name " id="access-statement"><a routerLink="/club/access-statement">Access Statement</a></li>
                        <!-- <li class="courses-name " id="ground-development"><a href="#">Ground Development </a></li> -->
                    </ul>
                </div>
            </div>
            <div class="club-fischer-section course-main-content active" id="premier-outdoor-content">
                <div class="club-fischer-section">
                    <div class="container">
                        <div class="club-fischer-detail" *ngFor="let venue of premieroutdoorList?.data">
                            <div class="club-fischer-image">
                                <img [src]="venue?.image">
                            </div>
                            <div class="club-fischer-content premier-outdoor-section">
                                <div class="titel-box">
                                    <h2 class="titel-name">{{venue?.title}}</h2>
                                </div>
                                <div class="club-fischer-text" [innerHTML]="venue?.description">
                                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                                </div>
                                <div class="club-fischer-btn">
                                    <a href="{{venue?.pdf}}" download *ngIf="venue?.pdf"> {{venue?.btn_title}}</a> &nbsp;
                                    <a href="{{venue?.btn_url}}" target="_blank" *ngIf="venue?.btn_url">{{venue?.btn_title_2}}</a>
                                </div>
                            </div>
                        </div>
                        <div class="club-facilities-section" *ngIf="premieroutdoorimgList">
                            <div class="titel-box">
                                <h2 class="titel-name">{{premieroutdoorimgList?.title}} </h2>
                            </div>
                            <div class="club-facilities-detail">
                                <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidefacilitiesConfig">
                                    <div ngxSlickItem class="club-facilities-box slide" *ngFor="let venuefirst of premieroutdoorimgList?.club_premier_outdoor_venue_title_image">
                                        <div class="club-facilities-box-iamge">
                                            <img [src]="venuefirst?.image">
                                        </div>
                                    </div>
                                    
                                </ngx-slick-carousel>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club-fischer-current-event-section" [ngStyle]="{'background-image':'url(' + bannereventList?.file + ')'}" *ngIf="bannereventList">
                    <div class="container">
                        <div class="club-fischer-current-event-detail">
                            <a href="{{bannereventList?.url}}">
                                <p>{{bannereventList?.title}}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="club-fischer-bottom-section">
                    <div class="container">
                        <div class="club-fischer-bottom-detail" *ngIf="premieroutdoorimgsecList">
                            <div class="titel-box">
                                <h2 class="titel-name">{{premieroutdoorimgsecList?.title}} </h2>
                            </div>
                            <div class="club-facilities-detail">
                                <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideconcertsConfig">
                                    <div ngxSlickItem class="club-facilities-box slide" *ngFor="let venuesec of premieroutdoorimgsecList?.club_premier_outdoor_venue_title_image">
                                        <div class="club-facilities-box-iamge">
                                            <img [src]="venuesec?.image">
                                        </div>
                                    </div>
                                    
                                </ngx-slick-carousel>
                            </div>
                        </div>
                        <div class="club-fischer-bottom-detail" *ngIf="premieroutdoorimgthirdList">
                            <div class="titel-box">
                                <h2 class="titel-name">{{premieroutdoorimgthirdList?.title}} </h2>
                            </div>
                            <div class="club-facilities-detail" >
                                <ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidePefectConfig">
                                    <div ngxSlickItem class="club-facilities-box slide" *ngFor="let venuethird of premieroutdoorimgthirdList?.club_premier_outdoor_venue_title_image">
                                        <div class="club-facilities-box-iamge">
                                            <img [src]="venuethird?.image">
                                        </div>
                                    </div>
                                    
                                </ngx-slick-carousel>
                            </div>
                        </div>
                        <div class="perfect-location-section cf">
                            <div class="titel-box">
                                <h2 class="titel-name">The Perfect Location</h2>
                            </div>
                            <div class="perfect-location-list">
                                <ul>
                                    <li>10th largest city in the UK</li>
                                    <li>Largest economy in the East Midlands</li>
                                    <li>Named as the UK's Greatest Sporting City</li>
                                </ul>
                            </div>
                            <div class="perfect-location-text">
                                <p>Within easy reach of all Leicester’s transport links including motorway, 
                                    bus and rail connections across the country.</p>
                            </div>
                            <div class="perfect-location-bottom">
                               <div class="perfect-location-bottom-left">
                                   <ul>
                                       <li>
                                           <span class="perfect-location-icon"><img src="assets/images/acco.svg"></span>
                                           <span>
                                               <h3>By Train</h3>
                                               <p>Leicester Train Station: 2 Miles</p>
                                           </span>
                                       </li>
                                       <li>
                                            <span class="perfect-location-icon"><img src="assets/images/by-car.svg"></span>
                                            <span>
                                                <h3>By Car</h3>
                                                <p>M69/ M1 Junction 21: 3 Miles</p>
                                            </span>
                                        </li>
                                        <li>
                                            <span class="perfect-location-icon"><img src="assets/images/acco.svg"></span>
                                            <span>
                                                <h3>Accommodation</h3>
                                                <p>Nearest Hotel: Within 1 mile</p>
                                            </span>
                                        </li>
                                   </ul>
                               </div>
                               <div class="perfect-location-bottom-right">
                                    <ul>
                                        <li>
                                            <span class="perfect-location-icon"><img src="assets/images/by-bus.svg"></span>
                                            <span>
                                                <h3>By Bus</h3>
                                                <p>Leicester St Margaret's Bus Station: 3 Miles</p>
                                            </span>
                                        </li>
                                        <li>
                                            <span class="perfect-location-icon"><img src="assets/images/by-air.svg"></span>
                                            <span>
                                                <h3>By Air</h3>
                                                <p>East Midlands Airport: 21 Miles<br>Birmingham Airport: 35 Miles</p>
                                            </span>
                                        </li>
                                    </ul>
                               </div>
                            </div>
                            <div class="map-image">
                                <div class="map-sec">
                                    <div id="map_holder">
                                        <div id="map-canvas"> </div>
                                    </div>
                                </div>
                                <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2422.886071272498!2d-1.1449826846459579!3d52.60783013746957!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4877672c15993c19%3A0x8c3da81c99cc2d23!2sLeicestershire%20County%20Cricket%20Club!5e0!3m2!1sen!2sin!4v1611982342640!5m2!1sen!2sin"  frameborder="0" style="border:0;" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe> -->
                            </div>
                            <div class="perfect-location-overlay"></div>
                        </div>
                        <div class="commercial-contact-us-section cf">
                            <div class="titel-box">
                               <h2 class="titel-name">Contact us</h2>
                            </div>
                            <div class="commercial-contact-content">
                               <p>If you're looking to explore commercial opportunities with Leicestershire County Cricket Club, the team are on-hand to discuss opportunities throughout the year.&nbsp;</p>
                               <p>Complete your details below and a member of the team will get back to you as soon as they can.&nbsp;</p>
                               <a href="#"> e - enquiries@leicestershireccc.co.uk</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="club-fischer-bottom-contact-section">
                    <div class="commercial-bottom-contact-form" style="background-image: url(assets/images/player-bg-img.png);">
                        <div class="container">
                            <div class="commercial-bottom-contact-detail">
                                <form class="commercialform" #contactusForm="ngForm" (ngSubmit)="clubContactus(contactusForm)" [ngClass]="{'success': contactSuccess}">
                                    <http-message types="success" [data]="contactSuccess" class="err-msg-block">
                                    </http-message>
                                    <http-message [type]="'error'" [data]="contactError" *ngIf="contactError"
                                       class="err-msg-block"></http-message>
                                    <div class="join-register-right-box">
                                        <div class="join-register-right-box-input half">
                                            <app-form-field validation="required" name="first_name" [(ngModel)]="contactRequest.first_name"
                                       class="app-group">
                                                <input appFieldInput class="register-style" placeholder="First Name" type="text">
                                            </app-form-field>
                                        </div>
                                        <div class="join-register-right-box-input half">
                                            <app-form-field validation="required" name="last_name" [(ngModel)]="contactRequest.last_name"
                                       class="app-group">
                                                <input appFieldInput class="register-style" placeholder="Last Name" type="text">
                                            </app-form-field>
                                        </div>
                                        <div class="join-register-right-box-input half">
                                            <app-form-field validation="required" name="email" [(ngModel)]="contactRequest.email"
                                       class="app-group">
                                                <input appFieldInput class="register-style" placeholder="Email Address" type="text">
                                            </app-form-field>
                                        </div>
                                        <div class="join-register-right-box-input half">
                                            <app-form-field validation="required" name="mobile_number" [(ngModel)]="contactRequest.mobile_number"
                                       class="app-group">
                                                <input appFieldInput class="register-style" placeholder="Mobile No" type="number">
                                        </app-form-field>
                                        </div>
                                        <div class="join-register-right-box-input half">
                                            <app-form-field validation="required" name="company_name" [(ngModel)]="contactRequest.company_name"
                                       class="app-group">
                                                <input appFieldInput class="register-style" placeholder="Company Name" type="text">
                                        </app-form-field>
                                        </div>
                                        <div class="join-register-right-box-input half">
                                            <app-form-field validation="required" name="type_of_event" [(ngModel)]="contactRequest.type_of_event"
                                       class="app-group">
                                                <input appFieldInput class="register-style" placeholder="Type of event" name="type_of_event" type="text" >
                                        </app-form-field>
                                        </div>
                                        <div class="join-register-right-box-input full">
                                            <app-form-field validation="required" name="message" [(ngModel)]="contactRequest.message"
                                       class="app-group">
                                                <textarea appFieldInput name="message" form="usrform" class="register-style" placeholder="Message">Message</textarea>
                                            </app-form-field>
                                        </div>
                                    </div>
                                    <div class="join-register-right-box">
                                        <div class="join-register-btn"><button id="reg_button" type="submit">Submit</button></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="commercial-bottom-contact-overlay"></div>
                    </div>
                </div>
            </div> 
            <div class="tab-section-detail course-main-content  " id="directions-content">
                <div class="container">
                    <div class="club-travelling-section-one cf" *ngIf="directionsfirstList">
                        <div class="titel-box">
                            <h2 class="titel-name">{{directionsfirstList?.title}}</h2>
                        </div>
                        <div class="club-travelling-detail">                           
                            <div class="club-travelling-bottom">                                
                                <ul class="directions-faq">
                                    <li class="faq-title " [ngClass]="{open: i == 0 }" *ngFor="let directionfaq of directionsfirstList?.club_directions_other; let i = index" >
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>{{directionfaq?.title}}<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content" [innerHTML]="directionfaq?.description">
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="club-travelling-section-two cf" *ngIf="directionssecList">
                        <div class="titel-box">
                            <h2 class="titel-name">{{directionssecList?.title}}</h2>
                        </div>
                        <div class="club-travelling-detail">
                            <div class="club-travelling-bottom">
                                <ul class="directions-two-faq">
                                    <li class="faq-title " [ngClass]="{open: i == 0 }" *ngFor="let directionfaq of directionssecList?.club_directions_other; let i = index" >
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>{{directionfaq?.title}}<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content" [innerHTML]="directionfaq?.description">
                                        </div>
                                    </li>
                                </ul>
                                <!-- <ul class="directions-faq">
                                    
                                    <li class="faq-title ">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>Arriva<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li>
                                    <li class="faq-title">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>Bus services from the Train Station<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li>
                                    <li class="faq-title ">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>Bus services running from St Margarets Bus Station in the City Centre:<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li>
                                    <li class="faq-title">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>Bus services running from Charles Street in the City Centre<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li>
                                    <li class="faq-title">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>Centrebus<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li>
                                </ul> -->
                                
                            </div>
                        </div>
                    </div>
                    <div class="club-fischer-section-bottom cf" *ngIf="directionsList?.data?.club_directions_other?.length > 0">
                        <div class="club-fischer-detail" *ngFor="let content of directionsList?.data?.club_directions_other">
                            <div class="club-fischer-image">
                                <img [src]="content?.image">
                            </div>
                            <div class="club-fischer-content">
                                <div class="titel-box">
                                    <h2 class="titel-name">{{content?.title}}</h2>
                                </div>
                                <div class="club-fischer-text" [innerHTML]="content?.description">
                                    <p>There is a taxi butler service available from main reception through our partnership with ADT Taxis. Alternatively, their website is available HERE and you can call 0116 255 5222 to book a taxi in Leicester.</p>
                                </div>
                                <div class="club-fischer-btn">
                                    <a href="{{content?.url}}">{{content?.btn_title}}</a>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="club-fischer-detail">
                            <div class="club-fischer-image">
                                <img src="assets/images/commercial-img.jpg">
                            </div>
                            <div class="club-fischer-content">
                                <div class="titel-box">
                                    <h2 class="titel-name">Food and Drink at <br> the Fischer County Ground,<br> Grace Road</h2>
                                </div>
                                <div class="club-fischer-text">
                                    <p>When you arrive at the ground, you will be able to purchase tea, coffee, full breakfast, bacon & sausage cobs and a selection of other snacks from the Meet throughout your visit. The Friends of Grace Road also offers tea/coffee and a selection of homemade cakes in the Meet. We offer a two and three course lunchtime menu in the Charles Palmer Suite which can be booked on arrival. For more information, please visit our Food and Drink page </p>
                                </div>
                                <div class="club-fischer-btn">
                                    <a href="javascript:void(0)">KNOW MORE</a>
                                </div>
                            </div>
                        </div>
                        <div class="club-fischer-detail">
                            <div class="club-fischer-image">
                                <img src="assets/images/commercial-img.jpg">
                            </div>
                            <div class="club-fischer-content">
                                <div class="titel-box">
                                    <h2 class="titel-name">Where to stay</h2>
                                </div>
                                <div class="club-fischer-text">
                                    <h3>The Belmont Hotel, Leicester</h3>
                                    <p>A unique, relaxing, family run hotel in Leicester City Centre. A highly-trained, warm and friendly hotel team are waiting to welcome you to our captivating and elegant property set in a Victorian conservation area in the heart of the city centre.  Situated in pretty New Walk, we are five minutes’ walk from Leicester train station, Leicester and De Montfort Universities and a short taxi ride to the Leicestershire Country Cricket Club plus the best shopping the city has to offer.  Free on-site parking is available to all our residents. </p>
                                </div>
                                <div class="club-fischer-btn">
                                    <a href="javascript:void(0)">Go to website</a>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <!-- <div class="club-end-section">
                        <div class="club-end-detail">
                            <p><span>{{directionssecList?.subtitle}}</span><a href="{{directionssecList?.btn_url}}">{{directionssecList?.btn_title}}</a></p>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="club-fischer-ground course-main-content  " id="ground-regulations-content">
                <div class="container">
                    <div class="club-travelling-section-one cf">
                        <!-- <div class="titel-box">
                            <h2 class="titel-name">Travelling by car</h2>
                        </div> -->
                        <div class="club-travelling-detail">
                            <div class="club-travelling-bottom">
                                <ul class="ground-faq">
                                    <li class="faq-title " [ngClass]="{ open: i == 0 }" *ngFor="let ground of groundregulationsList?.data; let i = index">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>{{ground?.title}}<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content" [innerHTML]="ground?.description">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li>
                                    <!-- <li class="faq-title">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>SMOKING POLICY<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li>
                                    <li class="faq-title">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>PROHIBITED ITEMS<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li>
                                    <li class="faq-title">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>RACISM POLICY<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li>
                                    <li class="faq-title">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>ANTI–COURTSIDERS POLICY<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li>
                                    <li class="faq-title">
                                        <a class="faq-add" href="javascript:void(0);">
                                           <h3>Admission and the right to remain within the ground is also on condition<span><img src="assets/images/fox-white.png"></span></h3>
                                        </a>
                                        <div class="faq-content">
                                            <p>For all fixtures no alcohol will be allowed into the ground. </p>
                                            <p>Members and non-members will be able to obtain alcoholic beverages once inside the ground. This is necessary to ensure the safety of all spectators and the process will be closely managed and controlled by the club and the police who may close bars at any time to restrict consumption.</p>
                                        </div>
                                    </li> -->
                                   
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="club-hero-access-statement course-main-content " id="access-statement-content">
                <div class="container" *ngIf="statementList?.data?.length > 0">
                    <div class="club-hero-detail" *ngFor="let access of statementList?.data">
                        <div class="club-hero-btn">
                            <a href="{{access?.pdf}}" download>{{access?.title}}</a>
                        </div>
                        <div class="club-hero-content" [innerHTML]="access?.description">
                            <!-- <p>Leicestershire County Cricket Club’s ground, the Fischer County Ground, Grace Road, is an accessible ground for disabled supporters and visitors.</p>
                            <p>There is a continuous unobstructed access route and designated car parking area to our principal entrance on Park Hill Drive. The route is free of hazards and has a minimum width of 1800mm.</p>                        
                            <p>Ramped access is provided to the Charles Palmer Suite, where there is an accessible toilet, and there is also a new lift to provide access to the upper floor in the Mike Turner Cricket Centre.</p> 
                            <p>Wheelchair users can sit in the disabled access areas which are situated in front of the Charles Palmer Suite. Please speak to one of our stewards on your arrival for more information.</p>                        
                            <p>Disabled parking is very limited and is allocated on a first come first served basis. For more information as to how book a parking space for individual matches, please contact the club on 0116 283 2128.</p>                        
                            <p>For blind/partially sighted customers, Leicestershire CCC offers regular public address announcements to keep everybody informed of events around the ground/on the field of play.</p> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="club-hero-section course-main-content " id="ground-development-content">
                <div class="container">
                    
                </div>
            </div>
    </div>
</section><!-- page ends-->